
import React, { createContext, useContext, ReactNode } from 'react';
import { Task } from '@/types/taskTypes';

interface FeedbackContextType {
  submitFeedback: (feedback: {
    description: string;
    priority: Task['priority'];
    userId?: string;
    timestamp: string;
  }) => void;
}

const FeedbackContext = createContext<FeedbackContextType | undefined>(undefined);

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return context;
};

interface FeedbackProviderProps {
  children: ReactNode;
  onFeedbackSubmit: (feedback: {
    description: string;
    priority: Task['priority'];
    userId?: string;
    timestamp: string;
  }) => void;
}

export const FeedbackProvider: React.FC<FeedbackProviderProps> = ({ 
  children, 
  onFeedbackSubmit 
}) => {
  const submitFeedback = (feedback: {
    description: string;
    priority: Task['priority'];
    userId?: string;
    timestamp: string;
  }) => {
    onFeedbackSubmit(feedback);
  };

  return (
    <FeedbackContext.Provider value={{ submitFeedback }}>
      {children}
    </FeedbackContext.Provider>
  );
};

// Export FloatingFeedbackButton for backward compatibility
export { default as FloatingFeedbackButton } from '@/components/feedback/FloatingFeedbackButton';
